<div class="not-found">
  <div class="not-found__box">
    <h1>401</h1>
    <p>You are not authorized to view this page.</p>
    <button class="btn btn--primary" (click)="gotoHome()">Go To Home</button>
  </div>

